const dummy = (x) => x;
function isFunction(f) {
    return typeof f === "function" ? f : false;
}
export function getFunction(fn1, fn2) {
    return isFunction(fn1) || isFunction(fn2) || dummy;
}
//# sourceMappingURL=GetFunction.js.map